// Достает id ролика из ссылки на YouTube (watch, youtu.be, shorts, embed)
// и возвращает адрес для встраивания в iframe; для не-YouTube ссылок - null
export const getYouTubeEmbedUrl = (url) => {
    const match = url?.match(/(?:youtube\.com\/(?:watch\?.*v=|shorts\/|embed\/)|youtu\.be\/)([\w-]{11})/);
    return match ? `https://www.youtube.com/embed/${match[1]}` : null;
}
